// in src/Dashboard.js
import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {
  Title,
  ResourceContextProvider,
  List,
  DataTable,
  TextField,
  ListButton,
} from "react-admin";
import ScatterChart from "../charts/fso2Scatter";
import { CustomDateField } from "../lib/datetime";
import { TemperaturePlot, RedoxPlot, DensityPlot } from "../charts/ferment";
import { DetailsButton } from "../lib/detailsButton";
import { useDeviceHiddenColumns } from "../lib/useDeviceHiddenColumns";
import { FERMENT_LIST_PHONE_HIDDEN_COLUMNS } from "./ferments";

const RecentFermentList = () => {
  // A <DataTable> in a horizontal-scroll wrapper, with the same per-device
  // column defaults as the main Ferments list, so the mini plots keep a
  // usable width on phones.
  const hiddenColumns = useDeviceHiddenColumns(
    FERMENT_LIST_PHONE_HIDDEN_COLUMNS,
  );
  return (
    <ResourceContextProvider value="ferments">
      <List
        perPage={3}
        pagination={false}
        sort={{ field: "startTime", order: "DESC" }}
        storeKey={false}
        exporter={false}
        actions={false}
        title=" "
        empty={false}
      >
        <DataTable
          rowClick={false}
          bulkActionButtons={false}
          hiddenColumns={hiddenColumns}
          sx={{ "& .RaDataTable-tableWrapper": { overflowX: "auto" } }}
        >
          <DataTable.Col source="ferment" label="Ferment" disableSort>
            <div>
              <TextField source="vesselName" />
              <br></br>
              <TextField source="lotName" style={{ fontWeight: "bold" }} />
            </div>
          </DataTable.Col>
          <DataTable.Col source="startTime" label="Started">
            <CustomDateField source="startTime" />
          </DataTable.Col>
          <DataTable.Col
            source="density"
            label="Density"
            disableSort
            sx={{ minWidth: 160 }}
          >
            <DensityPlot mini={true} />
          </DataTable.Col>
          <DataTable.Col
            source="temperature"
            label="Temperature"
            disableSort
            sx={{ minWidth: 160 }}
          >
            <TemperaturePlot mini={true} />
          </DataTable.Col>
          <DataTable.Col
            source="redox"
            label="Redox"
            disableSort
            sx={{ minWidth: 160 }}
          >
            <RedoxPlot mini={true} />
          </DataTable.Col>
          <DataTable.Col>
            <DetailsButton />
          </DataTable.Col>
        </DataTable>
      </List>
    </ResourceContextProvider>
  );
};

const DashboardCard = () => (
  <div>
    <Title title="Dashboard" />
    <h2>FS1 Free SO₂</h2>
    <Card>
      <CardContent style={{ padding: 0 }}>
        <ScatterChart />
      </CardContent>
    </Card>
    <h2>Recent Ferments</h2>
    <RecentFermentList />
    {/* flex-end instead of float:right, which misbehaves inside cards
        and on narrow screens */}
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        marginTop: 10,
      }}
    >
      <ListButton label="More Ferments ➤" resource="ferments" />
    </div>
  </div>
);

export default DashboardCard;
